import styled from "styled-components";

export const StyledDividerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
`;

export const StyledDivider = styled.div`
  height: 5px;
  width: 250px;
  background-color: ${(props) => props.theme.main};
`;
